// extracted by mini-css-extract-plugin
export var attention = "style-module--attention--e2684";
export var content = "style-module--content--cc043";
export var image = "style-module--image--cacd8";
export var item = "style-module--item--5f522";
export var list = "style-module--list--91d16";
export var title = "style-module--title--401b6";
export var wrapper = "style-module--wrapper--e08c9";